import { combineReducers } from 'redux'
import userInfoReducer from './UserInfo/reducer'
import wordsReducer from './Words/reducer'

const reducers = combineReducers({ userInfoReducer, wordsReducer })

export default {
  reducers
}
